import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { SanitizeHtml } from '@bd/bdcore-utilities';
import withData from '@bd/bdcore-data';
import PageHelmet from '@bd/bdcore-pagehelmet';
import { css } from '@bd/bdui-styles/emotion';
import HomesList from '../Homes/HomesResults';
import PlansList from '../Plans/PlansResults';
import PageWrapper from '../../components/PageWrapper';
import ComDetailHeader from './ComDetailHeader';
import ComDetailContent from './ComDetailContent';
import FooterForm from '../../components/FooterForm';
// import AccordionToggle from '../../components/AccordionToggle';
import { colors, typography } from '../../styles';

const styles = css`

  .Breadcrumbs_wrapper {
    padding:20px;
  }
  .Breadcrumbs_list {
    list-style: none;
    padding: 0;
    margin: 0;
  }
  .Breadcrumbs_listItem {
    display: inline-block;
    margin: 0;
    font-size: 14px;
    color: ${colors.color6};
    &:after {
      content: '/';
      margin: 0 5px;
      display: inline-block;
    }
    &:last-child:after {
      display: none;
    }
    a {
      color: ${colors.color2};
      font-weight: bold;
    }
  }
  .DetailHeader {
    @media (min-width: 992px) {
      padding: 20px 0 60px 0;
      background-color: #F5F5F5;
      margin: 0;
    }
  }

  .DetailHeader_content {
    position: relative;
    margin: 0 -15px;
    @media (min-width: 992px) {
      margin: 0;
    }
    h1 {
      font-weight: 700;
      font-size: 20px;
      line-height: 18px;
      margin: 0 0 10px 0;
      padding: 15px;
      color: ${colors.color1};
      span {
        font-size: 15px;
        font-weight: 400;
      }
      @media (min-width: 992px) {
        font-size: 24px;
        line-height: 24px;
        border-bottom: 1px solid ${colors.color2};
        padding: 0 0 15px 0;
        span {
          font-size: 18px;
        }
      }
    }
  }
  .DetailHeader_contentMapButton {
    position: absolute;
    right: 15px;
    top: 8px;
    background-image: url('/images/icon-map-pin-blue.svg');
    display: block;
    width: 30px;
    height: 40px;
    padding: 21px 0 0 0;
    background-size: 14px 25px;
    background-repeat: no-repeat;
    background-position: top center;
    text-align: center;
    color: ${colors.color1};
    font-size: 12px;
    font-weight: 700;
    @media (min-width: 992px) {
      right: 0;
    }
  }
  .DetailHeader_iconList {
    display: flex;
    list-style: none;
    margin: 0 0 15px 0;
    padding: 0 15px;
    @media (min-width: 992px) {
      padding: 10px 0 0 0;
    }
    li {
      font-size: 15px;
      line-height: 1;
      margin: 0 15px 0 0;
      @media (min-width: 1200px) {
        font-size: 16px;
        margin: 0 20px 0 0;
      }
    }
    li:last-child {
      margin: 0;
    }
  }
  .DetailHeader_iconListIcon {
    display: inline-block;
    vertical-align: middle;
    margin: -2px 5px 0 0;
  }
  .DetailHeader_priceWrapper {
    padding: 0 15px;
    margin: 0 0 15px 0;
    @media (min-width: 992px) {
      padding: 0;
    }
  }
  .DetailHeader_priceValue {
    font-size: 20px;
    color: ${colors.color1};
    font-weight: 700;
    margin: 0;
    @media (min-width: 992px) {
      font-size: 24px;
    }
  }
  .DetailHeader_priceMonthly {
    font-size: 14px;
    font-weight: 300;
    font-style: italic;
    margin-left: 5px;
    @media (min-width: 992px) {
      display: block;
      padding: 10px 15px;
      background-color: #FFFFFF;
      font-size: 18px;
      font-weight: 700;
      font-style: normal;
      margin: 15px 0 20px 0;
      color: ${colors.color2};
    }
  }
  .DetailHeader_buttonsWrapper {
    padding: 0 15px;
    margin: 0 0 30px 0;
    @media (min-width: 992px) {
      padding: 0;
    }
    span:focus {
      outline: none;
      box-shadow: none;
    }
  }
  .DetailHeader_iconButtonsList {
    list-style: none;
    display: flex;
    justify-content: flex-start;
    padding: 0;
    padding: 0 15px;
    @media (min-width: 992px) {
      padding: 0;
    }
  }
  .DetailHeader_iconButtonsListItem {
    text-align: center;
    width: 65px;
    cursor:pointer;
    @media (min-width: 1600px) {
      width: 85px;
    }
  }
  .DetailHeader_iconButtonsListItemIcon {
    width: 55px;
    height: 55px;
    background-color: ${colors.color1};
    border-radius: 50%;
    padding-top: 15px;
    text-align: center;
    margin: 0 auto 5px auto;
    @media (min-width: 1600px) {
      width: 75px;
      height: 75px;
      padding-top: 23px;
    }
    img {
      height: 21px;
      @media (min-width: 1600px) {
        height: 28px;
      }
    }
  }
  .DetailHeader_iconButtonsListItemLabel {
    font-size: 12px;
    color: ${colors.color1};
    @media (min-width: 1600px) {
      font-size: 14px;
    }
  }
  .DetailMenu {
    display: none;
    @media (min-width: 992px) {
      width: 100%;
      background-color: ${colors.color1};
      font:700 18px/1 ${typography.SansSerif};
      text-align: center;
      position:relative;
      z-index: 6;
      border-bottom:1px solid #333;
      display:block;
    }
  }
  .DetailMenu_list {
    list-style: none;
    margin: 0;
    display: block;
    position: relative;
    width: auto;
    left: auto;
    margin-left: 0;
    top: auto;
    box-shadow: none;
    text-align: center;
  }
  .DetailMenu_listItem {
    @media (min-width: 992px) {
      display: inline-block;
    }
    a {
      background-color: #FFFFFF;
      padding: 15px;
      border-bottom: 1px solid #EEEEEE;
      display: block;
      color: #333;
      transition: all .25s ease;
      text-decoration: none;
      text-transform: capitalize;
      &.active {
        color: ${colors.color2};
      }
      @media (min-width: 992px) {
          background-color: transparent;
          text-align: center;
          font-weight:700;
          color: ${colors.color4};
          padding: 25px 15px;
          border: 0;
          &.active {
            color: white;
          }
        }
    }
    a:hover, a:active, a:focus {
      color: ${colors.color2};
      @media (min-width: 992px) {
          color: white;
        }
    }
    }
  .DetailSection {
    position: relative;
    .ScrollTarget {
      position: absolute;
      display: block;
      top: -110px;
    }
  }
  .DetailSection_heading {
    color: ${colors.color1};
    padding: 15px 0;
    background-image: url('/images/icon-plus-blue.svg');
    background-position: calc(100% - 5px) center;
    background-repeat: no-repeat;
    background-size: 10px 10px;
    border-top: 1px solid #eeeeee;
    font:700 18px/1 ${typography.Serif};
    outline: 0 !important;
    @media (min-width: 992px) {
      font:700 32px/1 ${typography.Serif};
      border: 0;
      padding: 45px 0 15px 0;
      background-image: none;
    }
  }
  .DetailSection_heading-open {
    background-image: url('/images/icon-minus-blue.svg');
  }
  .DetailSection:last-child {
    .DetailSection_heading {
      border-bottom: 1px solid #eeeeee;
      @media (min-width: 992px) {
        border: 0;
      }
    }
  }
  .DetailSection_featuresImage {
    background-color: #CCCCCC;
    min-height: 300px;
    height: 100%;
    background-position: center center;
    background-size: cover;
    @media (min-width: 992px) {
      padding: 0;
    }
  }
  .DetailSection_featuresHeading {
    font:700 24px/1.2 ${typography.SansSerif};
    color: ${colors.color1};
    margin: 0 0 15px 0;
  }
  .DetailSection_featuresContent {
    background-color: #F5F5F5;
    padding: 15px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
    @media (min-width: 992px) {
      padding: 45px;
    }
  }
  .DetailSection_featuresList {
    ul {
      padding: 0;
      margin: 0 0 0 20px;
      font-size: 16px;
    }
    li {
      margin: 0 0 8px 0;
    }
  }
  .DetailSection_table {
    list-style: none;
    li:last-child {
      .DetailSection_tableLabel, .DetailSection_tableContent {
        border-bottom: 1px solid #EEEEEE;
      }
    }
  }
  .DetailSection_tableLabel {
    background-color: #F5F5F5;
    border-top: 1px solid #EEEEEE;
    padding: 10px 10px;
    font-weight: 700;
    font-size: 15px;
    height: 100%;
    text-transform:capitalize;
    @media (min-width: 992px) {
      font-size: 16px;
      padding: 15px 15px;
    }
  }
  .DetailSection_tableContent {
    border-top: 1px solid #EEEEEE;
    padding: 10px 10px;
    font-size: 15px;
    height: 100%;
    @media (min-width: 992px) {
      font-size: 16px;
      padding: 15px 45px;
    }
  }
  .DetailSection_CTAWrapper {
    width: 100%;
    padding: 30px;
    background-color: ${colors.color2};
    border: 8px solid ${colors.color2Lighter};
    background-image: url('/images/icon-arrow-circle-right.svg');
    background-position: calc(100% - 25px) center;
    background-repeat: no-repeat;
    display: block;
    @media (min-width: 1200px) {
      background-position: calc(100% - 50px) center;
    }
  }
  .DetailSection_CTAHeading {
    font-family: ${typography.Serif};
    font-size: 24px;
    line-height: 1;
    color: #FFFFFF;
    margin: 0 0 10px 0;
    font-weight: 700;
  }
  .DetailSection_CTABody {
    font-size: 18px;
    line-height: 1;
    margin: 0;
    color: #FFFFFF;
  }
  .text-link {
    color: ${colors.color5};
    text-decoration:none;
  }
  .DirectionSection {
    padding-bottom:30px;
    @media (min-width: 992px) {
      padding-bottom:60px;
    }
  }
  .DirectionSection_Media, .DirectionSection_Content {
    padding-bottom:20px;
  }
  p {
    font:300 16px/34px ${typography.SansSerif};
    margin-bottom:20px;
    @media (min-width: 480px) {
      font:300 16px/34px ${typography.SansSerif};
    }
  }
  .Photo_Expand {
    color: ${colors.color2};
    font:700 14px/1 ${typography.SansSerif};
    padding-bottom:20px;
    cursor:pointer;
  }
  .DetailContact {
    display:none;
    @media (min-width: 992px) {
      display:flex;
      flex-flow:row wrap;
      justify-content: center;
      color:white;
    }
    .btn {
      border-radius:6px;
      border:0;
      padding:15px 30px;
      margin:15px 0;
    }
    .DetailContact_Media {
      display:flex;
      flex-flow:column wrap;
      justify-content: center;
      padding:40px 20px 40px 40px;
      background: ${colors.color1};
      img {
        max-width: 100%;
        height:auto;
      }
    }
    .DetailContact_Content {
      display:flex;
      padding:40px 40px 40px 20px;
      background: ${colors.color1};
      flex-flow:column wrap;
      justify-content: center;
      .DetailContact_ContentHeading {
        font:700 32px/1.2 ${typography.Serif};
      }
      .DetailContact_ContentSubheading {
        font:300 22px/1.2 ${typography.SansSerif};
      }
      .DetailContact_ContentTelephone {
        font:700 18px/1.2 ${typography.SansSerif};
      }
    }

  }
  .DetailContact_ContentPhone {
    color:white;
    font-weight:900;
    &:hover {
      color:white;
    }
  }
  .DetailHeader_Address {
    padding:0 15px 15px 15px;
    @media (min-width: 992px) {
      padding:0 ;
    }
  }
  .DetailHeader_price {
    font:700 24px/1.2 ${typography.SansSerif};
    color: ${colors.color1};
    padding:0 15px 15px 15px;
    @media (min-width: 992px) {
      padding:0 0 10px 0;
    }
  }
  .DetailHeader_Hours {
    padding-bottom:20px;
  }
  .FilterSortButton_wrapper {
    display:none;
  }
`;

const videoLightBoxStyle = css`
  position: relative;
  width: 80%;
  padding-top: calc(80% * 0.5625);
  margin-top: -22%;
  top: 50%;
  margin-left: 10%;

  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`;

function CommunityDetail({ community, homes, plans }) {
  const carouselSlides = [
    get(community, 'logo'),
    ...get(community, 'photos', []),
  ];

  if (get(community, 'tourUrl')) {
    carouselSlides.splice(1, 0, {
      type: 'tour',
      element: (<div className={`Carousel_imageElement ${videoLightBoxStyle}`}><iframe title="Virtual Tour" src={get(community, 'tourUrl')} /></div>),
    });
  }

  if (get(community, 'videos', []).length) {
    carouselSlides.splice(1, 0, ...get(community, 'videos', []).map(video => ({
      type: 'video',
      element: (<div className={`Carousel_imageElement ${videoLightBoxStyle}`} dangerouslySetInnerHTML={SanitizeHtml(video)} />),
    })));
  }

  return (
    <PageWrapper>
      <PageHelmet community={community} />
      <div className={styles}>
        <ComDetailHeader />
        <ComDetailContent />
        {
          get(homes, 'length') > 0 &&
          <div>
            <h2 className="container">Available Homes</h2>
            <HomesList homes={homes} />
          </div>
        }
        {
          get(plans, 'length') > 0 &&
          <div>
            <h2 className="container">Floor Plans</h2>
            <PlansList plans={plans} />
          </div>
        }
      </div>
      <FooterForm />
    </PageWrapper>
  );
}

CommunityDetail.propTypes = {
  community: PropTypes.object.isRequired,
  homes: PropTypes.arrayOf(PropTypes.object),
  plans: PropTypes.arrayOf(PropTypes.object),
};

CommunityDetail.defaultProps = {
  community: undefined,
  homes: undefined,
  plans: undefined,
};

export default withData(
  {
    community: true,
    homes: true,
    plans: true,
  },
  {
    required: {
      community: true,
    },
    ifMissing404: true,
  },
)(CommunityDetail);



// WEBPACK FOOTER //
// ./src/pages/CommunityDetail/index.js